import ParentView from '../components/parent-view'
import { listToTree, deepTraverse, flatMenuConfig } from '../utils/assist'
import RESOURCE_TYPE from './resource-type'

var uid = 1

// 用于动态菜单生成
class Menu {
    constructor(options) {
        this.init(options)
    }

    init(options = {}) {
        this.options = Object.assign({}, Menu.options, options)

        this.routes = []
        this.flatRoutes = []
        this.mapRoutes = {}
        this.hashRoutes = {}
        this.namedRoutes = {}
        this.message = { menu: {} } // 菜单名称，多语言对象
        this.homeRoute = null
    }

    // 是否目录
    isDirectory(item) {
        return item.type == RESOURCE_TYPE.directory
    }

    // 是否菜单
    isMenu(item) {
        return item.type == RESOURCE_TYPE.menu
    }

    // 根据权限动态生成菜单
    build(list) {
        var resTree = [],
            resMap = {},
            options = this.options

        // 获取目录、菜单、页签
        listToTree(list.filter(v =>
            v.type == RESOURCE_TYPE.root ||
            v.type == RESOURCE_TYPE.directory ||
            v.type == RESOURCE_TYPE.menu ||
            v.type == RESOURCE_TYPE.tab), {
            id: 'id',
            pId: 'pid',
            done(tree, map, list) {
                // 根节点过滤
                if(options.rootUri.length){
                    resTree = tree.filter(r => options.rootUri.indexOf(r.uri) >= 0)
                }else{
                    resTree = tree
                }
                
                resMap = map
            }
        })

        // clear
        this.routes = []
        this.flatRoutes = []
        this.mapRoutes = {}
        this.hashRoutes = {}
        this.message = { menu: {} }
        this.homeRoute = null

        // 从根子级开始
        resTree = resTree.reduce((acc, v) => {
            if (v.type == RESOURCE_TYPE.root) {
                acc.push(...v.children)
            }

            if (v.type == RESOURCE_TYPE.directory || v.type == RESOURCE_TYPE.menu) {
                acc.push(v)
            }

            return acc
        }, [])

        if (!resTree || resTree.length <= 0) {
            return this
        }

        resTree.sort((a, b) => a.sortNum - b.sortNum)
            .forEach(item => {
                var path = item.id, // 路由使用id
                    name = this.createRouteName(item),
                    rootRes = resMap[item.pid] // 根目录根可能被过滤

                // 顶层路由比较特殊，必须挂载在main之下
                var main = this.createRoute({
                    path: '/page',
                    name: name,
                    meta: {
                        id: item.id,
                        pid: item.pid,
                        icon: item.icon,
                        title: item.title,
                        hideInMenu: !item.displayable,
                        parentUri: rootRes ? rootRes.uri : "",
                    },
                    component: options.resolveMain,
                })

                if (this.isDirectory(item) && item.children && item.children.length > 0) {
                    main.meta.isDirectory = true
                    main.meta.showAlways = true
                    main.children = this.generateRoutes(item.children, main)
                } else {
                    main.name = "main" + item.id
                    main.meta.targetName = main.name
                    main.meta.hide = true // 不在面包屑导航出现
                    main.children = this.generateRoutes([item], main)
                }

                this.routes.push(main)
                this.message.menu[main.name] = item.title
            })

        return this
    }

    // 生成嵌套路由，深度遍历
    generateRoutes(items, parent) {
        var childRoutes = []

        items.sort((a, b) => a.sortNum - b.sortNum).forEach(item => {
            var path = item.id,
                name = this.createRouteName(item)

            var route = this.createRoute({
                path,
                name,
                meta: {
                    id: item.id,
                    pid: item.pid,
                    icon: item.icon,
                    title: item.title,
                    uri: item.uri,
                    parentUri: parent.meta.uri,
                    fullPath: parent.meta.fullPath + '/' + path,
                    resType: item.type,
                    hideInMenu: !item.displayable,
                }
            })

            if (item.children && item.children.length > 0) {
                // 目录下挂菜单
                if (this.isDirectory(item)) {
                    route.component = ParentView
                    route.meta.isDirectory = true
                    route.meta.showAlways = true

                    route.children = this.generateRoutes(item.children, route)
                }

                // 菜单下挂分区
                if (this.isMenu(item)) {
                    route.component = null
                    route.children = this.generateViews(item.children, route)
                }
            } else {
                route.component = null
            }

            this.message.menu[name] = item.title

            childRoutes.push(route)
        })

        return childRoutes
    }

    // 生成嵌套视图、广度遍历
    generateViews(items, root) {
        var stack = [...items],
            views = [],
            me = this

        if (items.length < 0) {
            return []
        }

        var sections = [],
            last,
            level = items[0].level,
            route,
            item

        function round(sections, parent) {
            // 子视图
            var route = me.createRoute({
                path: '', // 作为默认子路由
                meta: {
                    hideInMenu: true,
                    hide: false,
                    parentUri: parent.meta.uri
                },
                components: {},
            })

            // 以uri命名
            sections.forEach(v => {
                route.components[v.uri] = null
            })

            return route
        }

        // 广度遍历
        while ((item = stack.shift())) {
            // 收集同级视图
            if (item.level == level) {
                sections.push(item)
            } else if (item.level > level) {
                // 为上一次收集创建路由
                route = round(sections, last || root)

                // 路由级联
                if (last) {
                    last.children = [route]
                } else {
                    views.push(route)
                }

                last = route
                level = item.level

                // 开始下一轮收集
                sections = [item]
            }

            // 向下遍历
            if (item.children && item.children.length > 0) {
                stack.push(...item.children)
            }
        }

        // 处理剩余的sections
        if (sections.length > 0) {
            if (last) {
                last.children = [round(sections, last)]
            }
            // 首轮未处理
            else {
                last = round(sections, root)
                views.push(last)
            }
        }

        // 原菜单成为管道路由
        if (last) {
            last.name = root.name
            last.meta.title = root.meta.title
            last.meta.targetName = root.name

            delete root.name
            this.namedRoutes[last.name] = last
            root.meta.targetName = last.name
            root.meta.defaultChildId = last.meta.uid
        }

        return views
    }

    // 生成路由名称
    createRouteName(item) {
        return item.code || item.id
    }

    // 创建路由
    createRoute(config) {
        var meta = config.meta || {},
            route

        uid++

        route = {
            path: config.path,
            meta: {
                // 路由uid
                uid: uid,
                // id
                id: meta.id,
                // pid
                pid: meta.pid,
                // 菜单图标
                icon: "_" + (meta.icon || this.options.defaultMenuIcon),
                // 菜单标题
                title: meta.title || '',
                // 跳转目标
                targetName: meta.targetName || config.name,
                // 逻辑父级（name由前端决定）
                parentName: '',
                // 菜单uri（uri由后端决定）
                uri: meta.uri || `front/uri/${uid}`,
                // 父级菜单uri
                parentUri: meta.parentUri || '',
                // 菜单全路径
                fullPath: meta.fullPath || config.path,
                // 是否目录
                isDirectory: meta.isDirectory || false,
                // 面包屑导航中是否隐藏
                hide: meta.hide || false,
                // 菜单是否隐藏，默认显示菜单和目录，其它隐藏
                hideInMenu: meta.hideInMenu || false,
                // 强制显示为折叠子菜单
                showAlways: meta.showAlways || false,
                // 是否keep-alive
                keepAlive: meta.keepAlive || false,
                // 路由权限 vue-can会用到
                access: meta.uri ? [meta.uri] : null,
                // 资源类型
                resType: meta.resType || -1,
                // 默认子路由id
                defaultChildId: meta.defaultChildId,
                // 是否默认子路由
                isDefaultRoute: config.path == "",
                // 缓存静态声明
                /*
                    [key1, key2, key3]
                */
                /*
                {
                    [key]:{
                        default: Any, // 初始值
                        expire: Number, // 0 到期时间
                        query: Boolean false, // 是否区分查询字符串
                        user: Boolean true, // 是否区分用户
                    },

                    [key]: expire
                }
                */
                cache: [],
            },
            // 嵌套路由     
            children: []
        }

        // 别名
        if (config.name) {
            route.name = config.name
        }

        // 重定向
        if (config.redirect) {
            route.redirect = config.redirect
        }

        // 组件
        if (config.component) {
            route.component = config.component
        } else if (config.components) {
            route.components = config.components
        }

        // 缓存
        this.flatRoutes.push(route)
        this.hashRoutes[route.meta.uid] = route

        if (route.meta.uri) {
            this.mapRoutes[route.meta.uri] = route
        }

        if (route.name) {
            this.namedRoutes[route.name] = route
        }


        return route
    }

    // 设置动态主页
    setHomeRoute(homeName) {
        var homeRoute = this.flatRoutes.find(v => v.meta.uri == homeName || v.meta.uri == "/" + homeName)

        if (homeRoute) {
            homeRoute.name = homeName
            
            var rootRoute = this.flatRoutes.find(v => v.name == "__root__")

            // 补充根路由
            if (!rootRoute) {
                rootRoute = this.createRoute({
                    path: '/',
                    name: "__root__",
                    redirect: {
                        name: homeName
                    },
                    meta: {
                        hideInMenu: true,
                    },
                })

                this.routes.push(rootRoute)
            }
        }

        this.homeRoute = homeRoute
    }

    // 更新路由配置
    updateRoutes(menuConfig = {}) {
        menuConfig = flatMenuConfig(menuConfig)

        this.flatRoutes.forEach(route => {
            var dyr

            // 只对末级菜单有效
            if (route.children.filter(v => !v.meta.hideInMenu).length <= 0) {
                // uri查询
                dyr = menuConfig[route.meta.uri]

                if (dyr) {
                    var defaultChild

                    // 带默认子视图（页签场景）
                    if (route.meta.defaultChildId) {
                        defaultChild = this.hashRoutes[route.meta.defaultChildId]
                    }

                    // reset component
                    route.component = dyr.component

                    // rename
                    if (dyr.name) {
                        var oldName

                        // name比较特殊，defaultChild代表了其父路由
                        if (defaultChild) {
                            oldName = defaultChild.name

                            route.meta.targetName = dyr.name
                            defaultChild.name = dyr.name
                            defaultChild.meta.targetName = dyr.name

                            // 命令路由处理
                            delete this.namedRoutes[oldName]
                            this.namedRoutes[dyr.name] = defaultChild
                        } else {
                            oldName = route.name

                            if (oldName != dyr.name) {
                                route.name = dyr.name
                                route.meta.targetName = dyr.name

                                // 命令路由处理
                                delete this.namedRoutes[oldName]
                                this.namedRoutes[dyr.name] = route
                            }
                        }

                        // 命名翻译处理
                        delete this.message[oldName]
                        this.message.menu[dyr.name] = route.meta.title
                    }

                    // set logical parent
                    if (dyr.meta && dyr.meta.parentName) {
                        route.meta.parentName = dyr.meta.parentName
                    }

                    // reset path
                    if (dyr.path) {
                        var oldPath = route.path

                        route.path = dyr.path
                        route.meta.fullPath = route.meta.fullPath.replace(oldPath, dyr.path)
                    }

                    // reset keepAlive
                    if (dyr.meta && typeof dyr.meta.keepAlive !== "undefined") {
                        route.meta.keepAlive = dyr.meta.keepAlive

                        // 默认路由跟随
                        if (defaultChild) {
                            defaultChild.meta.keepAlive = dyr.meta.keepAlive
                        }
                    }

                    // set cache
                    if (dyr.meta && dyr.meta.cache) {
                        if (defaultChild) {
                            defaultChild.meta.cache = dyr.meta.cache
                        } else {
                            route.meta.cache = dyr.meta.cache
                        }
                    }
                }
            }

            // 路由视图
            if (route.components) {
                Object.keys(route.components).forEach(uri => {
                    dyr = menuConfig[uri]

                    if (dyr) {
                        route.components[uri] = dyr.component
                    }
                })
            }
        })

        // 设置默认parentName
        this.routes.forEach(v => deepTraverse(v, (route, parent) => {
            if (!route.meta.parentName && parent) {
                // 若parent.name不存在，则这是一个管道路由，将其视为透明
                route.meta.parentName = parent.name ? parent.name : parent.meta.parentName
            }
        }))
    }

    // 创建Menu示例
    static create() {
        return new Menu()
    }
}

// static
Menu.options = {
    // 动态主页名称
    homeName: "",

    // 主路由页面
    resolveMain: ParentView,

    // 菜单配置
    menuConfig: {},

    // 默认图标
    defaultMenuIcon: "menu-indent",

    // 根节点uri
    rootUri: ['admin/root'],
}

export default Menu
